<template>
    <div>
        <b-row>
            <b-col md="12">
                <b-card text-variant="center" class="card card-congratulations">
                    <b-img
                        :src="
                            require('@/assets/images/elements/decore-left.png')
                        "
                        class="congratulations-img-left"
                    /><b-img
                        :src="
                            require('@/assets/images/elements/decore-right.png')
                        "
                        class="congratulations-img-right"
                    />
                    <b-avatar variant="primary" size="70" class="shadow mb-2">
                        <feather-icon size="28" icon="AwardIcon" />
                    </b-avatar>
                    <h1 class="mb-1 mt-50 text-white">
                        {{ heroTitle }}
                    </h1>
                    <b-card-text class="m-auto w-75">
                        {{ heroDescription }}
                    </b-card-text>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4">
                <b-card>
                    <b-avatar variant="primary" size="50" class="shadow mb-2">
                        <feather-icon size="28" icon="CpuIcon" />
                    </b-avatar>
                    <h2 class="text-primary mb-1">High Performance</h2>
                    <b-card-text>{{ featureHighPerformance }}</b-card-text>
                </b-card>
            </b-col>
            <b-col md="4">
                <b-card>
                    <b-avatar variant="primary" size="50" class="shadow mb-2">
                        <feather-icon size="28" icon="DownloadCloudIcon" />
                    </b-avatar>
                    <h2 class="text-primary mb-1">Instant Downloads</h2>
                    <b-card-text>{{ featureInstantDownload }} </b-card-text>
                </b-card>
            </b-col>
            <b-col md="4">
                <b-card>
                    <b-avatar variant="primary" size="50" class="shadow mb-2">
                        <feather-icon size="28" icon="CloudIcon" />
                    </b-avatar>
                    <h2 class="text-primary mb-1">Many Hosters</h2>
                    <b-card-text>{{ featureManyHosters }} </b-card-text>
                </b-card>
            </b-col>
            <b-col md="4">
                <b-card>
                    <b-avatar variant="primary" size="50" class="shadow mb-2">
                        <feather-icon size="28" icon="DollarSignIcon" />
                    </b-avatar>
                    <h2 class="text-primary mb-1">Prices</h2>
                    <b-card-text>{{ featurePrices }}</b-card-text>
                </b-card>
            </b-col>
            <b-col md="4">
                <b-card>
                    <b-avatar variant="primary" size="50" class="shadow mb-2">
                        <feather-icon size="28" icon="PocketIcon" />
                    </b-avatar>
                    <h2 class="text-primary mb-1">Trustly</h2>
                    <b-card-text>{{ featureTrustly }}</b-card-text>
                </b-card>
            </b-col>
            <b-col md="4">
                <b-card>
                    <b-avatar variant="primary" size="50" class="shadow mb-2">
                        <feather-icon size="28" icon="KeyIcon" />
                    </b-avatar>
                    <h2 class="text-primary mb-1">Payment Methods</h2>
                    <b-card-text>{{ featurePaymentMethods }}</b-card-text>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <b-card text-variant="center" border-variant="warning">
                    <b-avatar variant="warning" size="50" class="shadow mb-2">
                        <feather-icon size="28" icon="FlagIcon" />
                    </b-avatar>
                    <h2 class="text-warning mb-1">Legal</h2>
                    <b-card-text
                        >Our service acts like a gateway between you and the
                        filehost service, redirecting the file directly to you
                        from filehosts servers. We never save the file on our
                        servers, therefore <strong>Leechall.io</strong> is
                        totally within the boundaries of legal
                        work.</b-card-text
                    >
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="!this.$store.getters.isLoggedIn">
            <b-col md="12">
                <b-card text-variant="center" border-variant="primary">
                    <b-avatar variant="primary" size="70" class="shadow mb-2">
                        <feather-icon size="28" icon="LinkIcon" />
                    </b-avatar>
                    <h2 class="text-primary">
                        Create an account now! It's Free!
                    </h2>
                    <b-card-text class="font-small-4 mb-2">
                        Our service will not let you down.
                    </b-card-text>

                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        :to="{ name: 'auth-register' }"
                    >
                        Create Account
                    </b-button>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {
    BAvatar,
    BImg,
    BCol,
    BRow,
    BCard,
    BCardText,
    BLink,
    BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
    components: {
        BCol,
        BRow,
        BCard,
        BCardText,
        BLink,
        BImg,
        BButton,
        BAvatar,
    },
    directives: {
        Ripple,
    },
    mounted() {
        this.updateMeta();
    },
    watch: {
        "$route.path": function () {
            this.updateMeta();
        },
    },
    computed: {
        heroTitle() {
            return this.$route.path.startsWith("/premium-link-generator")
                ? "Welcome to LEECHALL.IO — Premium Link Generator"
                : "Welcome to LEECHALL.IO";
        },
        heroDescription() {
            return this.$route.path.startsWith("/premium-link-generator")
                ? "Download files instantly with fast speed, full support, and a one-time payment — no monthly fees, ad-free."
                : "LEECHALL.IO is a paid service that allows you to download files instantly at the best Internet speed.";
        },
        featureHighPerformance() {
            return this.$route.path.startsWith("/premium-link-generator")
                ? "Top-performance servers ensure your downloads are fast and smooth every time."
                : "We operate with the best network provider, processing your files quickly.";
        },
        featureInstantDownload() {
            return this.$route.path.startsWith("/premium-link-generator")
                ? "Get your files instantly without waiting or clicking ads."
                : "Get your files instantly through our easy-to-use interface.";
        },
        featureManyHosters() {
            return this.$route.path.startsWith("/premium-link-generator")
                ? "Supports all major file hosts, so you can download files without restrictions."
                : "A wide range of unrestricted hosts is offered.";
        },
        featurePrices() {
            return this.$route.path.startsWith("/premium-link-generator")
                ? "Affordable one-time payment for full access — no recurring fees."
                : "A lower price than the majority of file hosters while still offering more features and hosters.";
        },
        featureTrustly() {
            return this.$route.path.startsWith("/premium-link-generator")
                ? "Trusted since 2016, Leechall.io offers fast, reliable, ad-free downloads with one-time payment."
                : "Leechall.com has been trusted since 2016. Leechall.io continues to provide fast, ad-free downloads with one-time payment.";
        },
        featurePaymentMethods() {
            return this.$route.path.startsWith("/premium-link-generator")
                ? "Easy payment via Card, Paypal, Cryptocurrency, Payeer, Binance Pay, WebMone and more."
                : "Now accepting Card, Paypal, Cryptocurrency, Payeer, Binance Pay, WebMoney ...and more.";
        },
    },
    methods: {
        updateMeta() {
            if (
                this.$route.path === "/premium-link-generator" ||
                this.$route.path === "/premium-link-generator/"
            ) {
                const description =
                    "Generate premium download links instantly from multiple file hosts. No ads, high speed, and unlimited downloads with Leechall.io.";
                const ogTitle = "Premium Link Generator - Leechall.io";
                const ogDescription = description;
                const ogUrl =
                    window.location.origin + "/premium-link-generator";
                const ogImage = "https://leechall.io/logo.png";

                // Meta description
                let metaDescription = document.querySelector(
                    'meta[name="description"]'
                );
                if (!metaDescription) {
                    metaDescription = document.createElement("meta");
                    metaDescription.setAttribute("name", "description");
                    document.head.appendChild(metaDescription);
                }
                metaDescription.setAttribute("content", description);

                // Open Graph
                const setOg = (property, content) => {
                    let tag = document.querySelector(
                        `meta[property="${property}"]`
                    );
                    if (!tag) {
                        tag = document.createElement("meta");
                        tag.setAttribute("property", property);
                        document.head.appendChild(tag);
                    }
                    tag.setAttribute("content", content);
                };
                setOg("og:title", ogTitle);
                setOg("og:description", ogDescription);
                setOg("og:url", ogUrl);
                setOg("og:image", ogImage);

                // Twitter
                const setTwitter = (name, content) => {
                    let tag = document.querySelector(`meta[name="${name}"]`);
                    if (!tag) {
                        tag = document.createElement("meta");
                        tag.setAttribute("name", name);
                        document.head.appendChild(tag);
                    }
                    tag.setAttribute("content", content);
                };
                setTwitter("twitter:title", ogTitle);
                setTwitter("twitter:description", ogDescription);
                setTwitter("twitter:url", ogUrl);
                setTwitter("twitter:image", ogImage);
            }
        },
    },
};
</script>

<style></style>
